import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dices, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const asset = (u) => (!u ? null : u.startsWith("http") ? u : `${BACKEND}${u}`);

// Date-seeded "surprise mashup" card — one tap opens Mashup Studio pre-filled & ready to build.
export default function MashupOfTheDay() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/mashup/daily").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return null;

  const go = () => {
    const qs = new URLSearchParams(d.params || {}).toString();
    navigate(`/app/mashup?${qs}`);
  };

  return (
    <button onClick={go} data-testid="mashup-of-the-day"
      className="w-full text-left mb-8 rounded-3xl p-5 border border-fuchsia-400/40 bg-gradient-to-br from-fuchsia-500/10 via-transparent to-cyan-500/10 card-hover animate-rise flex items-center gap-4">
      <div className="relative shrink-0">
        <div className="w-16 h-16 rounded-2xl grid place-items-center bg-gradient-to-br from-fuchsia-500 to-cyan-500 text-3xl shadow-lg overflow-hidden">
          {d.image ? <img src={asset(d.image)} alt="" className="w-16 h-16 object-cover" /> : <span>{d.emoji || "🎲"}</span>}
        </div>
        <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-white shadow grid place-items-center"><Dices className="w-4 h-4 text-fuchsia-500" /></span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-bold uppercase tracking-wide text-fuchsia-500">🎲 Mashup of the Day</div>
        <div className="font-display text-lg font-extrabold truncate" data-testid="motd-title">{d.title}</div>
        <div className="text-sm text-[hsl(var(--muted-foreground))] truncate">{d.subtitle}</div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {(d.chips || []).map((c, i) => (
            <span key={i} className="px-2 py-0.5 rounded-full text-[11px] font-semibold bg-[hsl(var(--secondary))]">{c}</span>
          ))}
        </div>
      </div>
      <div className="shrink-0 self-center rounded-full bg-gradient-to-r from-fuchsia-500 to-cyan-500 text-white px-4 py-2 text-sm font-bold flex items-center gap-1">
        Build <ArrowRight className="w-4 h-4" />
      </div>
    </button>
  );
}
